module.exports = __webpack_public_path__ + "static/img/he-cen.d50b49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/he-cen.png
// module id = pyYH
// module chunks = 0